export default __webpack_public_path__ + "images/RW.27b6cba.png";